import _CALCULATE_RESPONSIVE_STATE from './CALCULATE_RESPONSIVE_STATE';
export { _CALCULATE_RESPONSIVE_STATE as CALCULATE_RESPONSIVE_STATE };